import { render } from "./sclfdzHome.vue?vue&type=template&id=756f67e9"
import script from "./sclfdzHome.vue?vue&type=script&lang=js"
export * from "./sclfdzHome.vue?vue&type=script&lang=js"

import "./sclfdzHome.vue?vue&type=style&index=0&id=756f67e9&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__